module.exports = __webpack_public_path__ + "img/1541574852.74c376c4.jpg";